import { createSlice } from '@reduxjs/toolkit';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { client } from '../../../utils/apolloClient';
import config from '../../../utils/config';

const initialState = {
  paymentSettings:{
    paymentSettingData:{},
    paymentSettingLoading: false,
    paymentSettingFailed: false
  }
};

export const getPaymentSettings = createAsyncThunk(
  'paymentSettingsSlice',
  async ({ emailId, token }) => {
    let response = await client.authorizeRequest({
      method: 'POST',
      url: `${config.serviceEndpoints.mpDpMetadataUrl}/getPaymentSettings`,
      data: {
        emailId:emailId
      },
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response;

  }
);

export const paymentSettings = createSlice({
  name: 'paymentSettingsSlice',
  initialState,
  extraReducers: {
    [getPaymentSettings.fulfilled]: (state, action) => {
      const paymentSettingData =action.payload.data.data
      state.paymentSettings = {
        paymentSettingData,
        paymentSettingLoading: false,
        paymentSettingFailed: false
      }
    },
    [getPaymentSettings.pending]: (state, action) => {
      state.paymentSettings = {
        paymentSettingData: [],
        paymentSettingLoading: true,
        paymentSettingFailed: false
      }
    },
    [getPaymentSettings.rejected]: (state, action) => {
      state.paymentSettings = {
        paymentSettingData: [],
        paymentSettingLoading: false,
        paymentSettingFailed: true
      }
    }
  }
});

export default paymentSettings.reducer;